import ReactDOM from "react-dom/client";
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import Home from "./pages/home/Home";
import Article from "./pages/article/Article";
import NotFoundPage from "./pages/404";
import Politicas from "./legal";
import AunTienesDudas from "./aun-tienes-dudas";

import './App.scss'

const root = ReactDOM.createRoot(
  document.getElementById("root")
);
root.render(
  <BrowserRouter basename="/ayuda">
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/article" element={<Article />}>
        <Route path=":articleId" element={<Article />} />
      </Route>
      <Route path='/politicas-de-privacidad' element={<Politicas />} />
      <Route path='/aun-tienes-dudas' element={<AunTienesDudas />} />
      <Route
        path="*"
        element={
          <NotFoundPage />
        }
      />
    </Routes>
  </BrowserRouter>
);